import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Building2, Users, Mail, Phone, MapPin } from 'lucide-react';

interface CustomerDetailsPanelProps {
  selectedCustomer: any;
}

export function CustomerDetailsPanel({ selectedCustomer }: CustomerDetailsPanelProps) {
  if (!selectedCustomer) {
    return (
      <Card className="glass-card">
        <CardHeader className="pb-3">
          <CardTitle className="text-base">Selected Account</CardTitle>
        </CardHeader>
        <CardContent className="p-6 text-center">
          <div className="flex flex-col items-center justify-center h-full">
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
              <Building2 className="w-8 h-8 text-muted-foreground" />
            </div>
            <p className="text-muted-foreground">Select an end user account to view details</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="glass-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Selected Account</CardTitle>
      </CardHeader>
      <CardContent className="p-6 text-center">
        {selectedCustomer && selectedCustomer.id &&
          <div className="space-y-2">
            <div className="w-12 h-12 bg-worldsview-blue/20 rounded-full flex items-center justify-center mx-auto">
              <Building2 className="w-6 h-6 text-worldsview-blue" />
            </div>
            <div>
              <h4 className="font-semibold">{selectedCustomer.name}</h4>
              <p className="text-sm text-muted-foreground">{selectedCustomer?.end_user_id}</p>
              <p className="text-xs text-muted-foreground mb-2">CSN: {selectedCustomer?.csn}</p>
              <Badge
                variant="outline"
                className={`text-xs ${selectedCustomer.status === 'Active'
                    ? 'bg-worldsview-green/10 text-worldsview-green border-worldsview-green/20'
                    : selectedCustomer.status === 'Pending Renewal'
                      ? 'bg-worldsview-orange/10 text-worldsview-orange border-worldsview-orange/20'
                      : 'bg-worldsview-blue/10 text-worldsview-blue border-worldsview-blue/20'
                  }`}
              >
                {selectedCustomer.status}
              </Badge>

              <div className="space-y-2 text-left mt-3">
                <div className="flex items-center gap-2 text-sm">
                  <Users className="w-3 h-3 text-worldsview-blue flex-shrink-0" />
                  <span className="truncate">{selectedCustomer.contacts[0]?.first_name} {selectedCustomer.contacts[0]?.last_name}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Mail className="w-3 h-3 text-worldsview-blue flex-shrink-0" />
                  <span className="truncate">{selectedCustomer.contacts[0]?.email}</span>
                </div>
                <div className="flex items-center gap-2 text-sm">
                  <Phone className="w-3 h-3 text-worldsview-blue flex-shrink-0" />
                  <span className="truncate">{selectedCustomer.contacts[0]?.phone_number}</span>
                </div>
              </div>
            </div>
          </div>
        }

      </CardContent>
    </Card>
  );
}